module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- REMINDER: change this back to dc_url when documentcloud problem is fixed -->\n'+
((__t=( version ))==null?'':_.escape(__t))+
': <a href="'+
((__t=( url ))==null?'':_.escape(__t))+
'" target="_blank">'+
((__t=( description ))==null?'':_.escape(__t))+
' <i class="fa-solid fa-file-pdf"></i></a>\n';
 if (distance > 0) { 
__p+='\n  <br>\n  <span class="small-text">\n    Change from previous: '+
((__t=( Math.round(distance * 100) ))==null?'':__t)+
'%\n  </span>\n';
 } 
__p+='\n';
}
return __p;
};
